import { useFormik } from "formik";
import React from "react";
import * as Yup from "yup";
import apiRequest from "../../../../utils/admin/apiRequest";
import usePost from "../../../../hooks/api/usePost";
import Alert from "../../../ui/utils/Alert";
import InputField from "../../../ui/form/InputField";
import CheckboxField from "../../../ui/form/CheckboxField";
import Button from "../../../ui/utils/Button";

const Edit = ({ data, closeModal, callback }) => {
  const { error, isLoading, post, serverErrors } = usePost(
    apiRequest.editVendorManagerPaymentGateway
  );

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      razorpay: {
        isEnabled: data?.razorpay?.isEnabled ?? true,
        keyId: data?.razorpay?.keyId || "",
        keySecret: data?.razorpay?.keySecret || "",
        webhookSecret: data?.razorpay?.webhookSecret || "",
      },

      scanToPay: {
        isEnabled: data?.scanToPay?.isEnabled ?? false,
        upiId: data?.scanToPay?.upiId || "",
        payeeName: data?.scanToPay?.payeeName || "",
        qrImage: data?.scanToPay?.qrImage || "",
      },

      isActive: data?.isActive ?? true,
    },

    validationSchema: Yup.object({
      razorpay: Yup.object({
        isEnabled: Yup.boolean(),
        keyId: Yup.string().when("isEnabled", {
          is: true,
          then: (s) => s.required("Razorpay Key ID is required"),
        }),
      }),

      scanToPay: Yup.object({
        isEnabled: Yup.boolean(),
        upiId: Yup.string().when("isEnabled", {
          is: true,
          then: (s) => s.required("UPI ID is required"),
        }),
      }),
    }),

    onSubmit: async (values) => {
      // at least one enabled
      if (!values.razorpay.isEnabled && !values.scanToPay.isEnabled) {
        alert("At least one payment method must be enabled");
        return;
      }

      const payload = {
        razorpay: values.razorpay.isEnabled
          ? {
              isEnabled: true,
              keyId: values.razorpay.keyId,
              ...(values.razorpay.keySecret && {
                keySecret: values.razorpay.keySecret,
              }),
              webhookSecret: values.razorpay.webhookSecret,
            }
          : { isEnabled: false },

        scanToPay: values.scanToPay.isEnabled
          ? {
              isEnabled: true,
              upiId: values.scanToPay.upiId,
              payeeName: values.scanToPay.payeeName,
              qrImage: values.scanToPay.qrImage,
            }
          : { isEnabled: false },

        isActive: values.isActive,
      };

      const response = await post({
        data: { id: data?._id, body: payload },
      });

      if (response?.response) {
        callback?.();
        closeModal();
      }
    },
  });

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">
        Update Vendor Payment Gateway
      </h2>

      <div className="border-b" />

      <form onSubmit={formik.handleSubmit} className="text-sm">
        {error && <Alert message={error} type="error" />}

        <div className="grid grid-cols-1 gap-3 p-4 sm:grid-cols-2">
          <CheckboxField
            label="Enable Razorpay"
            checked={formik.values.razorpay.isEnabled}
            onChange={(e) =>
              formik.setFieldValue(
                "razorpay.isEnabled",
                e.target.checked
              )
            }
          />
           <CheckboxField
            label="Enable Scan to Pay (UPI)"
            checked={formik.values.scanToPay.isEnabled}
            onChange={(e) =>
              formik.setFieldValue(
                "scanToPay.isEnabled",
                e.target.checked
              )
            }
          />

          {formik.values.razorpay.isEnabled && (
            <>
              <InputField
                name="razorpay.keyId"
                label="Razorpay Key ID"
                value={formik.values.razorpay.keyId}
                onChange={formik.handleChange}
                error={formik.errors?.razorpay?.keyId}
                serverError={serverErrors?.razorpay?.keyId}
              />

              <InputField
                type="password"
                name="razorpay.keySecret"
                label="Razorpay Key Secret"
                placeholder="********"
                value={formik.values.razorpay.keySecret}
                onChange={formik.handleChange}
              />

              <InputField
                name="razorpay.webhookSecret"
                label="Webhook Secret"
                value={formik.values.razorpay.webhookSecret}
                onChange={formik.handleChange}
              />
            </>
          )}

          {/* Scan to Pay */}
         

          {formik.values.scanToPay.isEnabled && (
            <>
              <InputField
                name="scanToPay.upiId"
                label="UPI ID"
                placeholder="vendor@upi"
                value={formik.values.scanToPay.upiId}
                onChange={formik.handleChange}
                error={formik.errors?.scanToPay?.upiId}
              />

              <InputField
                name="scanToPay.payeeName"
                label="Payee Name"
                value={formik.values.scanToPay.payeeName}
                onChange={formik.handleChange}
              />
            </>
          )}

          
        </div>
          <div className="px-4 py-1">
              <CheckboxField
            label="Is Active"
            checked={formik.values.isActive}
            onChange={(e) =>
              formik.setFieldValue("isActive", e.target.checked)
            }
          />
          </div>

        <div className="border-b" />

        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>

          <Button
            type="submit"
            variant="primary"
            isLoading={isLoading}
            loadingText="Updating..."
          >
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Edit;
